module.exports = {
      id: "google-plain-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-61dfca8afc3dd3934ecf034e99eaf2c3.svg#google-plain",
      toString: function () {
        return this.url;
      }
    }